/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Support component names relative to this directory:
import * as ActiveStorage from '@rails/activestorage';
import '../utils/direct_uploads.js'
import { polyfill } from 'es6-promise'; polyfill();
import 'core-js/stable';
import 'regenerator-runtime/runtime';

ActiveStorage.start();

var componentRequireContext = require.context('components', true)
var ReactRailsUJS = require('react_ujs')
window.ReactRailsUJS = ReactRailsUJS
ReactRailsUJS.useContext(componentRequireContext)
